'use client';
import { useResponsive } from '@web-libs/core/responsiveness/use-responsive';
import { useTageaRouter } from '@web-libs/core/routing/application/use-tagea-router.concern';
import { Logo } from '@web-libs/features/branding/logo/ui/logo';
import { getCssVar } from '@web-libs/features/colors/application/colors';
import { EmergencyButton } from '@web-libs/features/emergency';
import { SidebarItem, useSidebarItems } from '@web-libs/features/navigation/sidebar-items';
import { LanguageSelector } from '@web-libs/ui/ui-components/language-selector/language-selector';
import { CSSProperties, useEffect, useState } from 'react';
import { useOwnUser } from '../users/application/use-own-user.concern';

export const TageaSidebar = () => {
  const sidebarItemDefinitions = useSidebarItems();

  const logo = (
      <Logo fitParent />
  );

  const { isDesktop, isSmallDesktop, isSmallHeight } = useResponsive();

  const _style: CSSProperties = {
    position: 'fixed',
    width: 130,
    top: 32,
    left: 32,
    backgroundColor: getCssVar('lightShadier'), // Adjust color as needed
    maxHeight: 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '25px 25px',
    borderRadius: '15px',
    height: '100%',
  };

  const sidebarItemsStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flex: 1,
    maxHeight: '500px',
    padding: '20px 0'
  }
  const sidebarIconsSize = isSmallHeight ? 40 : 70

  const router = useTageaRouter();

  const changeToWhiteColor = (event: any) => {
    event.target.style.color = 'var(--light)';
  }

  const changeToPrimaryColor = (event: any) => {
    event.target.style.color = 'var(--text-color)';
  }

  const [showEmergencyButton, setShowEmergencyButton] = useState(false);
  const {isEmployee} = useOwnUser();

  useEffect(() => {
    isEmployee().then((isEmployee) => {
      if(!isEmployee) {
        setShowEmergencyButton(true);
      }
    });
  }, []);

  return (
    <div>
      <div style={_style}>
        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
          {isDesktop && isSmallHeight ? null : <div style={{marginBottom: "16px"}}>{logo}</div>}
          <LanguageSelector background={'lightShadier'} />
        </div>
        <div style={sidebarItemsStyle}>
          {sidebarItemDefinitions.map((sidebarItemDefinition, index) => (
            <SidebarItem
              key={index}
              icon={sidebarItemDefinition.icon}
              iconSize={sidebarIconsSize}
              active={sidebarItemDefinition.active}
              navDestination={sidebarItemDefinition.navDestination}
              notification={sidebarItemDefinition.notification}
            />
          ))}
        </div>
        <div style={{ fontSize: 12 }}>
          {showEmergencyButton && <EmergencyButton size={isSmallDesktop ? 60 : 70} svgSize={isSmallDesktop ? 24: 32} style={{display: "flex"}}/>}
          {
            isDesktop && (
              <div style={{display:"flex", flexDirection: "column", alignItems: "center",marginTop:8}}>
                <a style={{color: getCssVar("textColor")}} onMouseEnter={changeToWhiteColor} onMouseLeave={changeToPrimaryColor} href={router.getLink('impressum')}>Impressum</a>
                <a style={{color: getCssVar("textColor")}} onMouseEnter={changeToWhiteColor} onMouseLeave={changeToPrimaryColor} href={router.getLink('datenschutz')}>Datenschutz</a>
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

